exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-button-danger {\n  font-size: 15px; }\n\n.edit-tag .tag-error {\n  font-size: 14px;\n  margin-top: 15px;\n  color: red; }\n\n.edit-tag .uk-list-line li {\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/tags/tag-view/tag-view.component.scss
// module id = ../../../../../src-admin/app/components/tags/tag-view/tag-view.component.scss
// module chunks = main